import React from "react";
import "./UserAvatar.css";
import appLib from "../../src/libs/appLib.mjs";

const UserAvatar = class extends React.Component {
	constructor(props) {
		super(props);
		const name = props.name || appLib.player2name(props.player);
		if ( name ) {
			const cls = ['UserAvatar'];
			if (props.group) cls.push('group');
			if (props.small) cls.push('small');
			if (props.strong) cls.push('strong');
			this.state = {
				className: cls.join(' '),
				title: name,
				icon: props.icon ||
					( props.player && appLib.player2icon(props.player)) ||
					name.replace(/^(.)\w*\W/i, "$1").replace(/^(.)[^A-Z]*([A-Z])/, "$1$2").substring(0, 2)
			};
		}
	}
	render() {
		if ( ! this.state?.icon ) return '';
		return (
			<span
				className={this.state.className}
				title={this.state.title}
			>
			{this.state.icon}
		</span>
		);
	}
}

export default UserAvatar;
